
/*!
* Copyright (c) Microsoft Corporation.
* All rights reserved. See LICENSE in the project root for license information.
* THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
* TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
*/
import {
  AsyncResult,
  callActionOrExecute,
  DataServiceQuery,
  IContext,
  IDataServiceRequest,
  IQueryResultSettings,
  // @ts-ignore -- Unused import
  NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';


function createCatalogProductListQuery(): DataServiceQuery {
  return new DataServiceQuery();
}


export function createCatalogProductListInput (
  productList:
    Entities.ProductList,
  catalogId:
    number
): IDataServiceRequest {
  const query = createCatalogProductListQuery();
  return query.createDataServiceRequestForOperation(
    'CreateCatalogProductList',
    true,
    DataServiceEntities.CreateCatalogResponseEntityExtensionClass
    ,
    'false',
    { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICreateCatalogResponseEntity' },
    {
      productList: productList,
      catalogId: catalogId
    }
  );
}

export function createCatalogProductListAsync (
  context: IContext, productList:
    Entities.ProductList,
  catalogId:
    number
): AsyncResult<DataServiceEntities.ICreateCatalogResponseEntity> {
  const request = createCatalogProductListInput(productList, catalogId);
  return callActionOrExecute<DataServiceEntities.ICreateCatalogResponseEntity>(request, context.callerContext);
}

function deleteCatalogProductListQuery(): DataServiceQuery {
  return new DataServiceQuery();
}


export function deleteCatalogProductListInput (
  productListId:
    string,
  catalogId:
    number
): IDataServiceRequest {
  const query = deleteCatalogProductListQuery();
  return query.createDataServiceRequestForOperation(
    'DeleteCatalogProductList',
    true,
    ''
    ,
    'false',
    { bypassCache: 'get', returnEntity: '' },
    {
      productListId: productListId,
      catalogId: catalogId
    }
  );
}

export function deleteCatalogProductListAsync (
  context: IContext, productListId:
    string,
  catalogId:
    number
): AsyncResult<boolean> {
  const request = deleteCatalogProductListInput(productListId, catalogId);
  return callActionOrExecute<boolean>(request, context.callerContext);
}

function getCatalogProductListQuery(): DataServiceQuery {
  return new DataServiceQuery();
}


export function getCatalogProductListInput (
  queryResultSettings: IQueryResultSettings, catalogId:
    number,
  productListSearchCriteria:
    Entities.ProductListSearchCriteria
): IDataServiceRequest {
  const query = getCatalogProductListQuery().resultSettings(queryResultSettings);
  return query.createDataServiceRequestForOperation(
    'GetCatalogProductList',
    true,
    DataServiceEntities.EveProductListExtensionClass
    ,
    'true',
    { bypassCache: 'get', returnEntity: 'DataServiceEntities.IEveProductList' },
    {
      catalogId: catalogId,
      productListSearchCriteria: productListSearchCriteria
    }
  );
}

export function getCatalogProductListAsync (
  context: IContext, catalogId:
    number,
  productListSearchCriteria:
    Entities.ProductListSearchCriteria
): AsyncResult<DataServiceEntities.IEveProductList[]> {
  const request = getCatalogProductListInput(
    context.queryResultSettings || {}, catalogId, productListSearchCriteria);
  return callActionOrExecute<DataServiceEntities.IEveProductList[]>(request, context.callerContext);
}

function getInventoryLabelQuery(): DataServiceQuery {
  return new DataServiceQuery();
}


export function getInventoryLabelInput (
  queryResultSettings: IQueryResultSettings, availabilities:
    DataServiceEntities.IInventoryLabelInput[]
): IDataServiceRequest {
  const query = getInventoryLabelQuery().resultSettings(queryResultSettings);
  return query.createDataServiceRequestForOperation(
    'GetInventoryLabel',
    true,
    DataServiceEntities.InventoryLabelEntityExtensionClass
    ,
    'true',
    { bypassCache: 'get', returnEntity: 'DataServiceEntities.IInventoryLabelEntity' },
    {
      availabilities: availabilities
    }
  );
}

export function getInventoryLabelAsync (
  context: IContext, availabilities:
    DataServiceEntities.IInventoryLabelInput[]
): AsyncResult<DataServiceEntities.IInventoryLabelEntity[]> {
  const request = getInventoryLabelInput(
    context.queryResultSettings || {}, availabilities);
  return callActionOrExecute<DataServiceEntities.IInventoryLabelEntity[]>(request, context.callerContext);
}

function getCatalogWarehouseQuery(): DataServiceQuery {
  return new DataServiceQuery();
}


export function getCatalogWarehouseInput (
  catalogId:
    number
): IDataServiceRequest {
  const query = getCatalogWarehouseQuery();
  return query.createDataServiceRequestForOperation(
    'GetCatalogWarehouse',
    false,
    DataServiceEntities.GetCatalogWarehouseResponseExtensionClass
    ,
    'false',
    { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetCatalogWarehouseResponse' },
    {
      catalogId: catalogId
    }
  );
}

export function getCatalogWarehouseAsync (
  context: IContext, catalogId:
    number
): AsyncResult<DataServiceEntities.IGetCatalogWarehouseResponse> {
  const request = getCatalogWarehouseInput(catalogId);
  return callActionOrExecute<DataServiceEntities.IGetCatalogWarehouseResponse>(request, context.callerContext);
}
